<template>
  <div>
    <nav-bar/>
    <v-form ref="form" class="container mt-5">
      <div class="row">
        <div class="col-md-6">
          <!--          <div class="font-16 my-1 mt-4">
                      کاربر
                    </div>
                    <v-autocomplete
                        v-model="userModel"
                        :items="people"
                        :rules="required"
                        dense
                        flat
                        item-text="fullName"
                        item-value="Id"
                        label="لیست"
                        class="rounded-lg"
                        outlined>
                    </v-autocomplete>-->
          <div class="font-16 my-1 ">
            استان
          </div>
          <v-autocomplete
              v-model="province"
              :items="provinceItems"
              :rules="required"
              background-color="whiteMainColor"
              class="rounded-lg"
              dense
              flat
              item-text="Name"
              item-value="ProvinceId"
              outlined
              @change="loadCity"
          ></v-autocomplete>
          <div class="font-16 my-1">
            شهرستان
          </div>
          <v-autocomplete
              v-model="city"
              :items="cityItems"
              :rules="required"
              background-color="whiteMainColor"
              class="rounded-lg"
              dense
              flat
              item-text="Name"
              item-value="CityId"
              outlined
          ></v-autocomplete>
          <div class="font-16 my-1">
            آدرس
          </div>
          <v-textarea
              v-model="Address"
              :rules="required"
              class="mt-2"
              flat
              name="input-7-4"
              outlined
          ></v-textarea>
          <div class="font-16 my-1">
            کدپستی
          </div>
          <v-text-field
              v-model="ZipCode"
              :rules="ZipCodeRules"
              class=" mt-3"
              dense
              flat
              outlined
              type="number">
          </v-text-field>
          <div class="col-12 py-0">
            <div class="row">
              <div class="col-md-6 col-12 pr-0">
                <div class="font-16 my-1">
                  پلاک
                </div>
                <v-text-field
                    v-model="Plak"
                    :rules="required"
                    class="mt-3"
                    dense
                    flat
                    outlined
                    type="number">
                </v-text-field>
              </div>
              <div class="col-md-6 col-12 pl-0">
                <div class="font-16 my-1">
                  واحد
                </div>
                <v-text-field
                    v-model="Vahed"
                    class="mt-3"
                    dense
                    flat
                    outlined
                    type="number">
                </v-text-field>
              </div>
            </div>
          </div>
          <div class="col-12 py-0">
            <div class="row">
              <div class="col-md-6 col-12 pr-0">
                <div class="font-16 my-1">
                  نام گیرنده
                </div>
                <v-text-field
                    v-model="Name"
                    :rules="required"
                    class="mt-3"
                    dense
                    flat
                    outlined>
                </v-text-field>
              </div>
              <div class="col-md-6 col-12 pl-0">
                <div class="font-16 my-1">
                  نام خانوادگی گیرنده
                </div>
                <v-text-field
                    v-model="Family"
                    :rules="required"
                    class="mt-3"
                    dense
                    flat
                    outlined>
                </v-text-field>
              </div>
            </div>
          </div>
          <div class="col-12 py-0">
            <div class="row">
              <div class="col-md-6 col-12 pr-0">
                <div class="font-16 my-1">
                  شماره همراه گیرنده
                </div>
                <v-text-field
                    v-model="MobilePhone"
                    :rules="phoneNumberRules"
                    class=" mb-1"
                    dense
                    flat
                    outlined
                    type="number">
                </v-text-field>
              </div>
              <div class="col-md-6 col-12 pl-0">
                <div class="font-16 my-1">
                  کد ملی گیرنده
                </div>
                <v-text-field
                    v-model="NationalCode"
                    :rules="nationalCodeRules"
                    class="mb-1"
                    dense
                    flat
                    outlined
                    type="number">
                </v-text-field>
              </div>
            </div>
          </div>
          <div class="col-12 text-center">
            <v-btn v-if="isNew && !fromCart" color="primary" elevation="0" large rounded @click="defineAddress">
              <span class="font-16">انجام</span>
            </v-btn>
            <v-btn v-if="fromCart" color="primary" elevation="0" large rounded @click="defineAddress">
              <span class="font-16">ثبت و بازگشت به سبد خرید</span>
            </v-btn>
            <v-btn v-if="!isNew " color="primary" large rounded @click="editAddress">
              <span class="font-16">ویرایش</span>
            </v-btn>
          </div>
        </div>
        <div class="col-md-6">
          <v-btn class="loc-btn" icon @click="getCurrentLocation">
            <i class="fas fa-location font19px white--text"></i>
          </v-btn>
          <GmapMap
              ref="mapRef"
              :center="myCoordinates"
              :options='{ fullscreenControl: false, mapTypeControl: false }'
              :zoom="zoom"
              class="rounded-lg"
              style="height:500px"
              @click="mark">
            <GmapMarker
                v-for='(marker,index) in markers'
                :key="index"
                :animation="2"
                :clickable="true"
                :position="marker"
                @click="center=marker"/>
          </GmapMap>
          <div v-if="markers.length===0" class="validators">مشخص کردن مکان روی نقشه الزامی است</div>
        </div>
      </div>
    </v-form>
    <v-dialog
        v-model="showResultDialog"
        hide-overlay
        persistent
        width="530">
      <v-card class="text-center">
        <v-card-title class="justify-space-between primary-bg">
          <v-btn
              color="primary"
              icon
              small
              @click="showResultDialog = false"
          >
            <i class="fas fa-times font-16 ml-1"></i>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <div class="mb-0 black--text py-5">{{ dialogResult }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
    <FooterComponent/>
  </div>
</template>

<script>
import NavBar from "@/Academy/components/NavBar";
import FooterComponent from "@/Academy/components/Footer";

export default {
  name: "manageAddress",
  components: {FooterComponent, NavBar},
  metaInfo () {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  data: () => ({
    showLoaderDialog: false,
    fromCart: false,
    showResultDialog: false,
    dialogResult: null,
    Address: null,
    NationalCode: '',
    Name: null,
    Family: null,
    ZipCode: '',
    newsTitle: null,
    isNew: true,
    Plak: null,
    Vahed: null,
    userModel: null,
    people: [],
    province: null,
    provinceItems: [],
    required: [v => !!v || "پر کردن این فیلد الزامی است"],
    city: null,
    cityItems: [],
    myCoordinates: {
      lat: 35.723524,
      lng: 51.396660
    },
    zoom: 11,
    markers: [],
    ZipCodeRules: [
      v => !!v || 'کد پستی اجباری است',
      v => (v.length == 10 || v.length == 0) || 'کد پستی 10 رقم است.',
    ],
    nationalCodeRules: [
      v => !!v || 'کد ملی اجباری است',
      v => (v.length == 10 || v.length == 0) || 'کد ملی 10 رقم است.',
    ],
    phoneNumberRules: [
      v => !!v || 'شماره موبایل اجباری است',
      value => (value && value[0] === "0") || 'اولین رقم موبایل با عدد صفر شروع می شود ',
      value => (value && value.length === 11) || 'شماره موبایل 11 رقم است.',
    ],
    MobilePhone: '',
  }),
  mounted () {
    this.$convertFarsiNumber()
    if (this.$getUserData().token === '') {
      this.$router.replace({path: '/HomePage'})
    }
    if (this.$route.query.isNew === 'true') {
      this.isNew = true
      this.title = 'تعریف آدرس'
      this.newsTitle = 'تعریف آدرس'
      this.$getLocation({})
          .then(coordinates => {
            this.myCoordinates = coordinates;
            this.markers.push(this.myCoordinates)
          })
          .catch(error => console.log(error));
    } else {
      this.isNew = false
      this.getData()
      this.title = 'ویرایش آدرس'
      this.newsTitle = 'ویرایش آدرس'
    }
    if (this.$route.query.fromCart === 'true') {
      this.fromCart = true
    }
    this.getProvinces()
  },
  created () {
    if (this.$route.query.isNew === 'true') {
      if (this.markers.length > 0) {
        this.markers.pop()
        this.markers.push({lat: 32.4279, lng: 53.6880})
      } else {
        this.markers.push({lat: 32.4279, lng: 53.6880})
      }
    }

  },
  methods: {
    loadCity () {
      this.showLoaderDialog = true
      let selectedLocation = this.provinceItems.filter(x => x.ProvinceId === this.province)[0];
      if (selectedLocation !== undefined) {
        this.setMapCenter(selectedLocation.Latitude, selectedLocation.Longitude, selectedLocation.DefaultZoomLevel);
      }
      // this.removeCity()

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/GetCitiesByProvinceId?ProvinceId=" + this.province, requestOptions)
          .then(response => response.text())
          .then(result => {
            this.cityItems = JSON.parse(result)
            console.log(this.cityItems)
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    getProvinces () {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/GetProvinces", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.provinceItems = JSON.parse(result)
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    getCurrentLocation () {
      this.$getLocation({})
          .then(coordinates => {
            this.myCoordinates = coordinates;
            if (this.markers.length > 0) {
              this.markers.pop()
              this.markers.push(this.myCoordinates)
              this.$refs.mapRef.$mapPromise.then(map => map.panTo(coordinates));
            } else {
              this.markers.push(this.myCoordinates)
            }
          })
          .catch(error => console.log(error));
    },
    setMapCenter (lat, lng, zoom) {
      this.myCoordinates = {
        lat: lat,
        lng: lng
      }
      this.zoom = zoom
    },
    setPlace (event) {
      this.myCoordinates = {
        lat: event.geometry.location.lat(),
        lng: event.geometry.location.lng()
      };
      this.markers = [];
      this.markers.push(this.myCoordinates)
      this.area = event.name;
    },
    mark (event) {
      if (this.markers.length > 0) {
        this.markers.pop()
        this.markers.push({lat: event.latLng.lat(), lng: event.latLng.lng()})
      } else {
        this.markers.push({lat: event.latLng.lat(), lng: event.latLng.lng()})
      }
    },
    defineAddress () {
      this.$refs.form.validate()
      if (this.$refs.form.validate()) {
        let resStatus = null
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);

        let formdata = new FormData();
        formdata.append("ProvinceID", this.province);
        formdata.append("CityID", this.city);
        formdata.append("Address", this.Address);
        formdata.append("ZipCode", this.ZipCode);
        formdata.append("Plak", this.Plak);
        formdata.append("Vahed", this.Vahed);
        formdata.append("Latitude", this.markers[0].lat);
        formdata.append("Longitude", this.markers[0].lng);
        formdata.append("Name", this.Name);
        formdata.append("Family", this.Family);
        formdata.append("MobilePhone", this.MobilePhone);
        formdata.append("NationalCode", this.NationalCode);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "/Client/DefineDeliveryAddress", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {
              this.showLoaderDialog = false
              if (resStatus === 200) {
                if (this.isNew && this.fromCart === false) {
                  this.$router.push({path: 'listAddress'})
                }
                if (this.fromCart) {
                  this.$router.push({path: 'Cart'})
                }

              } else {
                this.dialogResult = result
                this.showResultDialog = true
              }
            })
            .catch(error => console.log('error', error));
      }
    },
    getData () {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/EditDeliveryAddress?deliveryAddressId=" + this.$route.query.id, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            console.log("json")
            console.log(json)
            this.province = json.modelInDb.ProvinceID
            this.cityItems = json.cities
            this.city = json.modelInDb.City.CityId
            this.Address = json.modelInDb.Address
            this.ZipCode = json.modelInDb.ZipCode
            this.Plak = json.modelInDb.Plak
            this.Vahed = json.modelInDb.Vahed
            this.Name = json.modelInDb.Name
            this.Family = json.modelInDb.Family
            this.MobilePhone = json.modelInDb.MobilePhone
            this.NationalCode = json.modelInDb.NationalCode
            this.markers.push({lat: json.modelInDb.Latitude, lng: json.modelInDb.Longitude})
            this.myCoordinates = {
              lat: json.modelInDb.Latitude,
              lng: json.modelInDb.Longitude
            }
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    editAddress () {
      this.showLoaderDialog = true
      this.$refs.form.validate()
      if (this.$refs.form.validate()) {
        let resStatus = null
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);

        let formdata = new FormData();
        formdata.append("ProvinceID", this.province);
        formdata.append("CityID", this.city);
        formdata.append("Address", this.Address);
        formdata.append("ZipCode", this.ZipCode);
        formdata.append("Plak", this.Plak);
        formdata.append("Vahed", this.Vahed);
        formdata.append("Latitude", this.markers[0].lat);
        formdata.append("Longitude", this.markers[0].lng);
        formdata.append("Name", this.Name);
        formdata.append("Family", this.Family);
        formdata.append("MobilePhone", this.MobilePhone);
        formdata.append("NationalCode", this.NationalCode);
        formdata.append("DeliveryAddressID", this.$route.query.id);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "/Client/EditDeliveryAddress", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {
                  this.showLoaderDialog = false
                  if (resStatus === 200) {
                    this.$router.push({path: 'listAddress'})
                  } else {
                    this.dialogResult = result
                    this.showResultDialog = true
                  }
                }
            )
            .catch(error => console.log('error', error));
      }
    }
  }
}
</script>

<style scoped>

</style>